async function addToCart(id, quantity = 1, properties={}){
  return fetch('/cart/add.js', {
    body: JSON.stringify({
      id: id,
      quantity: quantity,
      properties: properties
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (cart) {
    return cart.json();
  });
}

function ProductItem(){
  function bindAddToCartButton(el){
    el.addEventListener('click', handleAddToCart);
  }

  async function handleAddToCart(e){
    e.target.classList.add('disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    await addToCart(parseInt(e.target.dataset.variant), 1, {});


    e.target.classList.remove('disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.dispatchEvent(new CustomEvent('product:added',
      {
        bubbles: true,
        detail: {
          variant: e.target.dataset.variant,
          quantity: 1
        }
      }
    ));
  }

  function bulkBindAddToCartButton(){
    //Product items already in page
    document.querySelectorAll('.ProductItem__AddToCart[data-variant]').forEach((el)=>{
      bindAddToCartButton(el);
    });

    //Product items loaded asyncronosly (recommendations and recently viewed products)
    document.addEventListener('asyncloadedproduct::loaded', (e)=>{
      if(e.detail && typeof(e.detail.querySelectorAll) == "function"){
        e.detail.querySelectorAll('.ProductItem__AddToCart[data-variant]').forEach((el)=>{
          bindAddToCartButton(el);
        });
      }
    })
  }

  function init(){
    bulkBindAddToCartButton()
    document.addEventListener('collection:reloaded', bulkBindAddToCartButton);
  }

  init();
}

function CollectionLoadMore() {
  const LoadMoreButton = document.querySelector('[data-load-more]');
  if(LoadMoreButton === null) { return }

  const LoadMoreText = LoadMoreButton.querySelector('[data-load-more-text]');
  const LoadingText = LoadMoreButton.querySelector('[data-loading]');

  LoadMoreButton.addEventListener('click', () => {
    if(
      document.querySelector('[data-total-pages]') === null ||
      document.querySelector('[data-current-page]') === null
    ) { return }

    const totalPages = parseInt(document.querySelector('[data-total-pages]').value);
    const currentPage = parseInt(document.querySelector('[data-current-page]').value) + 1;
    const nextURL = document.querySelector('[data-next-url]').value.replace(/page=[0-9]+/,'page=' + (currentPage));

    LoadMoreButton.setAttribute('disabled', true);
    LoadMoreText.setAttribute('hidden', true);
    LoadingText.removeAttribute('hidden');

    fetch(nextURL)
      .then(response => response.text())
      .then(htmlData => {
        const parser = new DOMParser;
        const htmlDOM = parser.parseFromString(htmlData, 'text/html');
        
        htmlDOM.querySelectorAll('.Grid__Cell').forEach(product => {
          product.querySelector('.ProductItem').setAttribute('style','visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);');
          document.querySelector('.ProductList').append(product);
        });

        document.dispatchEvent(new CustomEvent('collection:reloaded'));

        document.querySelector('[data-current-page]').value = currentPage;
  
        if(currentPage >= totalPages) { 
          LoadMoreButton.setAttribute('hidden', true);
          return
        }
      })
      .catch(error => console.error({ error }))
      .finally(() => {
        LoadMoreButton.removeAttribute('disabled');
        LoadMoreText.removeAttribute('hidden');
        LoadingText.setAttribute('hidden', true);
      })
  });
}

function CustomerCountrySelection() {
  const CountrySelector = document.querySelector('select[name="register_country"]');
  if(CountrySelector === null) { return }

  CountrySelector.addEventListener('change', e => {
    CountrySelector.classList.add('selected');
    const countryInput = document.querySelector('input#customerCountry');
    if(countryInput === null) { return }
    countryInput.value = `country:${e.target.value}`;
  })
}

function CustomerAcceptsPrivacy(){
  const CustomerAcceptsPrivacyCheckbox = document.querySelector('#accepts_privacy');
  if(!CustomerAcceptsPrivacyCheckbox){return}

  CustomerAcceptsPrivacyCheckbox.addEventListener('change', (e)=>{
    let customerTagInput = document.querySelector('[name="customer[tags]"]');
    if(e.target.checked && customerTagInput){
      customerTagInput.value += ',privacyAccepted:' + e.target.value;
    }else if(customerTagInput){
      customerTagInput.value = customerTagInput.value.split(',')[0];
    }
  })
}
  
window.disclaimerBar = function (){
  function closeDisclaimerBars(disclaimerBar) {
    disclaimerBar.setAttribute('hidden', '')
  }

  function checkDisclaimerBarClosed(disclaimerBar) {
    const disclaimerBarId = disclaimerBar.getAttribute('data-section-id');
    const disclaimerBarClosed = localStorage.getItem(disclaimerBarId);

    if(disclaimerBarId && disclaimerBarClosed){
      const now = new Date();
      const diff = Math.floor((now - disclaimerBarClosed) / (1000*60*60*24))

      if(disclaimerBarClosed !== null && diff < 7) {
        return;
      }

      disclaimerBar.removeAttribute('hidden');
      localStorage.removeItem(disclaimerBarId);
    }else{
      disclaimerBar.removeAttribute('hidden');
    }
  }

  function disclaimerBarsListener(disclaimerBar) {
    const closeButton = disclaimerBar.querySelector('.DisclaimerBar__Close');

    if(closeButton){
      closeButton.addEventListener('click', (e) => {
        const disclaimerBar = e.target.closest('.DisclaimerBar');
        const section_id = disclaimerBar.getAttribute('data-section-id');
        closeDisclaimerBars(disclaimerBar);

        if(section_id != null){
          localStorage.setItem(section_id, new Date().getTime());
        }
      })
    }
  }

  function init(){
    if(document.querySelector('.DisclaimerBar')){
      const disclaimer_bars = document.querySelectorAll('.DisclaimerBar');
      disclaimer_bars.forEach(disclaimer_bar => {
        checkDisclaimerBarClosed(disclaimer_bar);
        disclaimerBarsListener(disclaimer_bar);
      });
    }
  }

  init();
}

window.quantityValidation = function (){
  function validateQuantity(e){

    const submit_form = e.target,
        min_cart_items = submit_form.querySelectorAll('[data-purchase-minquantity]');
    if (min_cart_items.length > 0 && submit_form.querySelector('.Cart__Checkout')?.classList?.contains('disabled')) {
      min_cart_items.forEach(item => {
        item.classList.add('highlight');
        item.querySelector('.CartItem__Alert').removeAttribute('hidden');
      });
      e.preventDefault();
    }

    // Handle maximum quantity validation
    const max_cart_items = submit_form.querySelectorAll('[data-purchase-maxquantity]');
    if (max_cart_items.length > 0) {
      max_cart_items.forEach(item => {
        item.classList.add('highlight');
        item.querySelector('.CartItem__Alert').removeAttribute('hidden');
      });
      e.preventDefault();
    }
  }

  function bindSubmit(){
    const submit_form = document.querySelector('form.Cart');
    if(submit_form){
      submit_form.addEventListener('submit', validateQuantity);
    }
  }

  function init(){
    bindSubmit();
  }

  init();
}


document.addEventListener('DOMContentLoaded', () => {
  ProductItem();
  CollectionLoadMore();
  document.addEventListener('collection:reloaded', CollectionLoadMore);
  CustomerCountrySelection();
  CustomerAcceptsPrivacy();
  window.disclaimerBar();
  window.quantityValidation();
})